module.exports = __webpack_public_path__ + "img/topic_b@2x.bbb4a0f3.png";